import React, { useEffect, useState , useRef} from 'react'
import { observer } from 'mobx-react';
import { useStore } from '../../../stores';
import PreviewBrief from '../BriefPreview';
import { useServerFilter } from "../../../hooks/useServerFilter";
import './style.scss';
import { OutlinedButton, FilterRefined , PaginationControls, SearchBar} from '../../../components';
import { Filter } from '../../../assets';
import { Project } from '../../../api';
const Credipple = `${process.env.REACT_APP_CDN_URL}/globalAssets/CredippleWhiteLogo.svg`;
const UserIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/people.png`;
const SearchIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/SearchIcon.svg`;
var mobile = require('is-mobile');
const Projects = observer(() => {
    const { projectStore, uiStore } = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [Projects, setProjects] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [ViewProject, setViewProject] = useState(false);
    const [SelectedProject, setSelectedProject] = useState({});
    const [Leads, setLeads] = useState([]);
    const [Professionals, setProfessionals] = useState([]);
    const [FilteredProjects, setFilteredProjects] = useState([]);
    const [isFilter, setIsFilter] = useState(false);
    const [isFilterCleared, setIsFilterCleared] = useState(true);
    const [FilterTerms, setFilterTerms] = useState([])
    const [AllUsers, setAllsers] = useState([]);
    const [Pagination, setPagination] = useState({ 
        currentPage :  1, 
        hasMore     : false, 
        nextCursor  : "", 
        prevCursor  : "",
        pageSize    : 8, 
        totalPages  : 0, 
        totalUsers  : 0
    })
    const isFirstRender = useRef(true);
    const { serverFilterProject } = useServerFilter({ projectStore, uiStore, setAvailBriefs:setProjects, setPagination, setYearSelected:"", searchTerm });
        
    useEffect(() => {
        getProjects("", "");
    }, []);
    useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false; 
        
            return; 
        }else{
            if(searchTerm !== ""){
                serverFilterProject("", searchTerm, "", "");
            }else{
                getProjects("", "");
            };
        };
    }, [searchTerm]);
    const getProjects = async (lastId, navId) => {
        uiStore.setLoading(true);
        try {
            const projectsArr = await projectStore.getProjects(lastId, navId);
            const validProjects = Array.isArray(projectsArr?.projects) ? projectsArr.projects : [];

            setProjects(validProjects);
            setPagination({
                currentPage :  projectsArr?.currentPage ?? 1,
                hasMore     :  projectsArr?.hasMore ?? false,
                nextCursor  :  projectsArr?.nextCursor ?? "",
                prevCursor  :  projectsArr?.prevCursor ?? "",
                pageSize    :  projectsArr?.pageSize ?? 8,
                totalPages  :  projectsArr?.totalPages ?? 0,
                totalItems  :  projectsArr?.totalBriefs ?? 0
            });
            forceUpdate();
        } catch (error) {
            console.error(error);
            uiStore.showNotification('Failed to fetch projects.', 'error');
        } finally {
            uiStore.setLoading(false);
        };
    };
    const handleSearchChange = (value) => {
        setSearchTerm(value);
        forceUpdate();
    };
    const filteredProjects = (isFilterCleared ? Projects : FilteredProjects).filter(itemProject => {
        const searchValue = searchTerm.toLowerCase();
        return (itemProject.title.toLowerCase().includes(searchValue));
    });
    const getSelectedProject = (id) => {
        let projects = Projects;
        let selectedProject = projects.find(project => project._id === id);

        if (!selectedProject) {
            uiStore.showNotification('Project not found.', 'error');
            return;
        }

        setSelectedProject(selectedProject);
        setViewProject(true);
        forceUpdate();
    };
    const backClicked = (e, isEdited) => {
        if (isEdited === true) {
            uiStore.setLoading(true);
            getProjects("", "") ;
            uiStore.showNotification('Project updated successfully.', 'success');
        }
        setViewProject(false);
    };
    function handleFilterClick() {
        setIsFilter(true);
    };
    function closeFilterMouseleave() {
        setIsFilter(false);
    };
    function closeCardClck() {
        setIsFilterCleared(true);
        closeFilterMouseleave();
        setFilterTerms([]);
    };
    function getSearchTerm(searchTerms) {
        let terms = FilterTerms;
        processProjectsFiltration(terms, searchTerms)
    };
    function handleFilterChange(items) {
        // Initialize an array to hold the projects to be filtered
        let projectsArr = [];

        // If no filter items are provided, use all projects; otherwise, use the filtered projects
        if (items.length === 0) {
            projectsArr = [...Projects];
        } else {
            projectsArr = [...FilteredProjects];
            projectsArr = [...Projects];
        };

        // If there are filter items, proceed to filter the projects
        if (items.length > 0) {
            // Filter projects based on whether any of the filter items match specific project properties
            let filteredProjs = projectsArr.filter((project) =>
                items.some((item) =>
                    (Array.isArray(project.serviceCategory) && project.serviceCategory.includes(item)) || // Match service category
                    item === project.contractType || // Match contract type
                    item === project.projectPlan?.[0]?.fulfillmentStage || // Match fulfillment stage
                    item === project.briefStatus || // Match brief status
                    item === project._id || // Match project ID
                    item === (Number(new Date(project.createdAt).getMonth()) + 1) || // Match project creation month
                    item === project.client?.firstName || // Match client first name
                    item === project.client?.lastName || // Match client last name
                    item === project.client?.company || // Match client company
                    item === project.client?.email || // Match client email
                    item === project.fulfillmentLead?.firstName || // Match talent partner first name
                    item === project.fulfillmentLead?.lastName || // Match talent partner last name
                    item === project.fulfillmentLead?._id // Match talent partner ID
                )
            );

            // Filter projects further based on active lead filters
            const activeLeadFilters = items.filter(id => Leads.some(lead => lead._id === id));
            if (activeLeadFilters.length > 0) {
                filteredProjs = filteredProjs.filter(project => activeLeadFilters.includes(project.fulfillmentLead?._id));
            }

            // Update the state to reflect the filtered projects and active filter terms
            setIsFilterCleared(false);
            setFilteredProjects(filteredProjs);
            setFilterTerms([...items]);
        } else {
            // If no filter items are provided, reset to show all projects
            setFilteredProjects([...Projects]);
            setIsFilterCleared(true);
            closeCardClck(); // Clear the filter UI
        }
    }
    function processProjectsFiltration(terms, newTerm) {

        let updatedTerms = [...terms];
        if (!updatedTerms.includes(newTerm)) {
            updatedTerms.push(newTerm);
        }

        // Filter projects based on updated terms
        let filteredProjs = Projects.filter((project) => {

            return updatedTerms.every((term) =>
                (Array.isArray(project.serviceCategory) && project.serviceCategory.includes(term)) || // Treat serviceCategory as an array
                term === project.contractType ||
                term === project.projectPlan?.[0]?.fulfillmentStage ||
                term === project.briefStatus ||
                term === project._id ||
                term === (Number(new Date(project.createdAt).getMonth()) + 1) ||
                term === project.client?.firstName ||
                term === project.client?.lastName ||
                term === project.client?.company ||
                term === project.client?.email ||
                term === project.fulfillmentLead?.firstName ||
                term === project.fulfillmentLead?.lastName ||
                term === project.fulfillmentLead?._id
            );
        });
        // Update state with filtered projects and terms
        setIsFilterCleared(false);
        setFilteredProjects(filteredProjs);
        setFilterTerms(updatedTerms);
    };
    function processProjectsRemoval(terms) {
        let filteredProjs = [];

        Projects.forEach((project) => {
            if (terms.includes(project.serviceCategory) ||
                terms.includes(project.contractType) ||
                terms.includes(project.projectPlan[0].fulfillmentStage) ||
                terms.includes(project.briefStatus) ||
                terms.includes(project._id) ||
                terms.includes(Number(new Date(project.createdAt).getMonth()) + 1)
            ) {
                if (!filteredProjs.includes(project)) {
                    filteredProjs.push(project);
                }
            }
        });

        setIsFilterCleared(false);
        setFilteredProjects(filteredProjs);
        setFilterTerms(terms);
    };
    const handlePageChange = (e) => {
        const ID  = e;
        if (ID === 'next' && Pagination.hasMore) {
            getProjects(Pagination.nextCursor, 'lastId');
        }else{
            if (Pagination.currentPage > 1) {
                getProjects(Pagination.prevCursor,'prevId');
            }
        }
    };
    if (mobile()) {
        return (
            <div>

            </div>
        );

    } else {
        return (
            <div className='ProjectsContainer'>
                <div className='ProjectsContainerHeader'>
                    <p>Projects</p>
                    <img src={Credipple} alt='Credipple Logo' style={{ marginRight: '0.9%' }} />
                </div>
                <div className='ProjectsContainerBody'>
                    {(ViewProject) ?
                        <PreviewBrief Briefs={Projects} setBriefs={setProjects} project={SelectedProject} AllUsers={AllUsers} navigateMainToPage={(e, isEdited) => backClicked(e, isEdited)} professionals={Professionals} leads={Leads} />
                        :
                        <>
                            <div className='projectFilterSearch'>
                                <div className='SearchSection' style={{ width: '100%' }}>
                                    <div className='numofItems'>
                                        <PaginationControls
                                            styles={{width: 'fit-content'}}
                                            currentPage={Pagination.currentPage}
                                            totalPages={Pagination.totalPages}
                                            onPageChange={handlePageChange}
                                            hasMore={Pagination.hasMore}    
                                        />
                                        {/* <p className='spancular'>{filteredProjects.length}</p> */}
                                    </div>
                                    <div className='filterSection' >
                                        <div onMouseEnter={handleFilterClick} className={FilterTerms.length === 0 ? 'filterContainer' : 'filterContainerAct'}>
                                            <span className='filterspan' >
                                                <img onMouseEnter={handleFilterClick} src={Filter} alt='' className='filterimg' />
                                            </span>
                                            {FilterTerms.length === 0 ? null :
                                                <p style={{ color: 'white', paddingLeft: '5%' }}>Filters({FilterTerms.length})</p>
                                            }
                                        </div>
                                    </div>
                                    {isFilter ?
                                        <FilterRefined Projects={Projects} Leads={Leads}
                                            getFilterTerm={getSearchTerm}
                                            terms={FilterTerms}
                                            handleFilterChange={handleFilterChange}
                                            CloseFilterML={closeFilterMouseleave} CloseCardClck={closeCardClck}
                                        />
                                        :
                                        null
                                    }
                                    <div className='search-bar-section' style={{ width: '25%', height: '50%' }}>
                                    <SearchBar
                                        onSearch={(e)=>handleSearchChange(e)}
                                        placeholder='Search'
                                        value = {searchTerm}
                                        debounceDelay={1000}
                                        disabled={false}
                                        className=''
                                        searchIconUrl={SearchIcon}
                                        style={{ width: '100%' }}
                                    />
                                    </div>
                                </div>
                            </div>
                            <div className='availableprojectsSection'>

                                {filteredProjects.length === 0 ? (
                                    <p className='noProjectsMessage'>No projects found</p>
                                ) : (
                                    filteredProjects.map((item, index) => {
                                        return (
                                            <div className='projectCard' key={index} onClick={() => getSelectedProject(item._id)}>
                                                <div className='viewprojectHeader'>
                                                    <p>{item.title || ''}</p>
                                                </div>
                                                <div className='viewProjectDetails'>
                                                    <div className='profileANdUserDetails'>
                                                        <div className='userProfile' >
                                                            <img src={UserIcon} style={{ width: '100%', height: '100%' }} />
                                                        </div>
                                                        <div className='userProfile-Details'>
                                                            {typeof item.client === 'object' ?
                                                                <>
                                                                    <p className='header' style={{ fontWeight: '700' }}>{item?.client ? `${item.client.firstName || ''} ${item.client.lastName || ''}` : ''}</p>
                                                                    <p className='value'>{item?.client?.email ? item.client.email.substring(0, 25) : item?.client?.website ? item.client.website.substring(0, 20) : ''}</p>

                                                                </>
                                                                :
                                                                <>
                                                                    <p className='header' style={{ fontWeight: '700' }}>Not Assigned</p>
                                                                    <p className='value'>Not Assigned</p>
                                                                </>
                                                            }

                                                        </div>
                                                    </div>
                                                    <div className='fulfillmentLeadDetails'>
                                                        <p className='header' style={{ fontWeight: '700' }}>Fulfillment Lead</p>
                                                        <p className='value'>{typeof item?.fullfilmentLead === 'object' ? `${item.fullfilmentLead.firstName || ''} ${item.fullfilmentLead.lastName || ''}` : 'Not Assigned'}</p>
                                                    </div>
                                                </div>
                                                <div className='viewDetailsContainer'>
                                                    <OutlinedButton className='detailsBtn'><p>View Details</p></OutlinedButton>
                                                </div>
                                            </div>
                                        )
                                    })
                                )}
                            </div>
                        </>}
                </div>
            </div>
        )
    }
})

export default Projects;